import {Component, OnInit} from '@angular/core';
import {ProjectMeasureService} from '../../../shared/services/project-measure/project-measure.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-project-measure-graphic-event-dyn',
  templateUrl: './project-measure-graphic-event-dyn.component.html',
  styleUrls: ['./project-measure-graphic-event-dyn.component.scss']
})
export class ProjectMeasureGraphicEventDynComponent implements OnInit {

  public isLoading: boolean = true;
  public filters: any;
  private measures: any[];
  public filteredMeasures: any[];

  constructor(
    private projectMeasureService: ProjectMeasureService,
    private toastrService: ToastrService,
    private translateService: TranslateService) {
  }

  onFiltersChange(filters): void {
    this.isLoading = true;
      this.projectMeasureService.getMeasureEventDyn(filters.startDate, filters.endDate, filters.selectedLocation).subscribe((data: any[]) => {
        if (data.length === 0) {
          this.toastrService.error(this.translateService.instant('NO_MEASURE_AVAILABLE_ON_THIS_TIME_RANGE'), this.translateService.instant('ERROR'));
        }
        this.measures = data;
        this.filteredMeasures = this.measures;
        this.filters = filters;
        this.isLoading = false;
      });
  }

  ngOnInit() {
    this.isLoading = false;
  }

}
